import { NgModule } from "@angular/core";

import { BannerComponent } from "./banner.component";

@NgModule({
  imports: [BannerComponent],
  exports: [BannerComponent],
})
export class BannerModule {}
